import { connect, MapStateToProps, MergeProps } from "react-redux";

import { CheckBoxComponent, CheckBoxComponentProps } from "@multiweb/reactComponents";
import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { isWorkflowReadOnly } from "../../../selectors";
import { WorkflowEditorProps } from "../../../types";

type WfCheckBoxProps = {
    /** Lokalizační klíč pro title a label. */
    readonly textLocKey: string;
} & CheckBoxComponentProps & WorkflowEditorProps;

type StateProps = {
    readonly isWorkflowReadOnly: boolean;
    readonly text: string;
};

const mapStateToProps: MapStateToProps<StateProps, WfCheckBoxProps, IAppState> = (state, { hostKey, textLocKey }) => ({
    isWorkflowReadOnly: isWorkflowReadOnly(state, hostKey),
    text: getPrimaryText(state, textLocKey) ?? "",
});

const mergeProps: MergeProps<StateProps, undefined, WfCheckBoxProps, CheckBoxComponentProps> = ({ isWorkflowReadOnly, text }, _dispatchProps, ownProps) => ({
    ...ownProps,
    title: text,
    label: text,
    disabled: isWorkflowReadOnly || ownProps.disabled,
});

export const WfCheckBox = connect(mapStateToProps, undefined, mergeProps)(CheckBoxComponent);
